howspace.translate = (key, params = {}) => {
    if (typeof howspace.translate.translations[key] !== 'string') {
        // Translation not found, return the key.
        return key;
    }

    // Add translation to a new string, so we don't modify the original.
    let translated = '' + howspace.translate.translations[key];

    // Replace all params (if any).
    Object.keys(params).forEach(key => {
        translated = translated.replace('%' + key + '%', params[key]);
    });

    return translated;
};

howspace.translate.translations = {};

howspace.translate.setTranslations = newTranslations => {
    real.onTierReady(real.TIER_2, () => {
        howspace.translate.translations = newTranslations;
    });
};
